import { useMemo } from 'react';

export const checkIsProduction = (): boolean => {
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    return !(hostname === 'localhost' || hostname.includes('uat.zoomlogi.com'));
  }
  return true;
};

export const useIsProduction = (): boolean => {
  return useMemo(() => checkIsProduction(), []);
};
